<div style="width:400px;">
  <div style="width:99%;">
    <span> <button class="btn btn border" (click)="saveInstitutionType()" [disabled]="!form.dirty">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-4">
          <label>
            Prefix
          </label>
          <input id="prefix" type="text" class="form-control form-control-sm" formControlName="prefix">
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>
            Gren
          </label>
          <input id="branchId" type="text" class="form-control form-control-sm" formControlName="branchId">
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <label>
            Beskrivning
          </label>
          <textarea id="description" type="text" rows="2" class="form-control form-control-sm" formControlName="description"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Grupp
          </label>
          <p-select *ngIf="groups.length > 0" appendTo="body" [options]="groups" formControlName="institutionGroupId" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setGroup($event)"></p-select>
        </div>
      </div>
    </form>
  </div>
</div>
